export default {
  input: 'w-[calc(100vw-40px)] md:w-[350px] lg:w-[409px] max-w-[409px]',
  inputsWrapper: 'flex flex-col gap-[24px]',
};
